"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";

export const cartInputs = [
  {
    name: "checkoutConfiguration",
    friendlyName: "Checkout configuration",
    type: "reference",
    model: getBuilderModelName("checkout"),
  },
  {
    name: "ageVerificationPopup",
    type: "object",
    subFields: [
      {
        name: "description",
        type: "richText",
        friendlyName: "Description of age verification popup",
      },
      {
        name: "successMessage",
        type: "richText",
        friendlyName: "Success message after successful age verification",
      },
      {
        name: "popupMode",
        type: "boolean",
        friendlyName: "Display age verification banner in popup mode",
      },
    ],
  },
  {
    name: "ageVerificationMethodImages",
    type: "reference",
    model: getBuilderModelName("age-verification-method-images"),
  },
] as const satisfies Inputs;

export const CartComponent: RegisteredComponent = {
  name: "Cart",
  component: dynamic(async () => (await import("./Cart")).Cart, {
    ssr: true,
  }),

  inputs: cartInputs,
};
